import { getYear } from 'date-fns';

export enum DatePart {
  day = 'day',
  month = 'month',
  year = 'year'
}

const datePartMinMaxValuesDictionary = {
  [DatePart.day]: {
    min: 1,
    max: 31,
  },
  [DatePart.month]: {
    min: 1,
    max: 12,
  },
  [DatePart.year]: {
    min: 1000,
    max: 2500,
    birthday: {
      min: 1900,
      max: getYear(new Date()),
    },
  },
};

export interface DatePartConfig {
  type: DatePart;
  label: string;
  placeholder: string;
  min: number;
  max: number;
}

export const getDatePartMinValue = (datePart: DatePart, isBirthday = true): number =>
  datePart === DatePart.year && isBirthday
    ? datePartMinMaxValuesDictionary[datePart].birthday.min
    : datePartMinMaxValuesDictionary[datePart].min;

export const getDatePartMaxValue = (datePart: DatePart, isBirthday = true): number =>
  datePart === DatePart.year && isBirthday
    ? datePartMinMaxValuesDictionary[datePart].birthday.max
    : datePartMinMaxValuesDictionary[datePart].max;

export const getDatePartsConfig = (locale: string, isBirthday: boolean): DatePartConfig[] => {
  const parts: DatePartConfig[] = [];
  const formatParts = new Intl.DateTimeFormat(locale).formatToParts(new Date());

  formatParts.forEach(obj => {
    switch (obj.type) {
      case DatePart.day:
        parts.push({
          type: DatePart.day,
          label: 'profile-form.composite_date_property.labels.day',
          placeholder: 'profile-form.composite_date_property.placeholders.day',
          min: getDatePartMinValue(DatePart.day),
          max: getDatePartMaxValue(DatePart.day),
        });
        break;
      case DatePart.month:
        parts.push({
          type: DatePart.month,
          label: 'profile-form.composite_date_property.labels.month',
          placeholder: 'profile-form.composite_date_property.placeholders.month',
          min: getDatePartMinValue(DatePart.month),
          max: getDatePartMaxValue(DatePart.month),
        });
        break;
      case DatePart.year:
        parts.push({
          type: DatePart.year,
          label: 'profile-form.composite_date_property.labels.year',
          placeholder: 'profile-form.composite_date_property.placeholders.year',
          min: getDatePartMinValue(DatePart.year, isBirthday),
          max: getDatePartMaxValue(DatePart.year, isBirthday),
        });
        break;
    }
  });

  return parts;
};

export const mapDatePartToString = (value: number): string => {
  const valueString = value.toString();
  return valueString.length < 2 ? valueString.padStart(2, '0') : valueString;
};
